<template>
  <el-select
    :value="innerValue"
    :multiple="multiple"
    :multiple-limit="limit"
    :disabled="disabled"
    filterable
    clearable
    :placeholder="placeholder"
    @input="onInput"
    @change="onChange"
    :loading="loading"
  >
    <el-option
      v-for="(opt, idx) in options"
      :key="idx"
      :label="opt.label"
      :value="opt.value"
    />
  </el-select>
</template>

<script>
import { agentListForUser } from '@/api/cardManagement/cardBill.js'

export default {
  name: 'AgentSelect',
  props: {
    value: {
      type: [Array, String, Number],
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    },
    limit: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择分销商'
    }
  },
  data() {
    return {
      options: [],
      loading: false,
      innerValue: this.value
    }
  },
  watch: {
    value(val) {
      this.innerValue = val
    }
  },
  mounted() {
    this.fetchOptions()
  },
  methods: {
    async fetchOptions() {
      this.loading = true
      try {
        const res = await agentListForUser()
        const list = Array.isArray(res) ? res : []
        this.options = list.map(item => ({
          label: item.agentName || item.name || '',
          value: item.agentId != null ? item.agentId : item.id
        }))
      } catch (e) {
        this.options = []
      } finally {
        this.loading = false
      }
    },
    onInput(val) {
      this.$emit('input', val)
    },
    onChange(val) {
      this.$emit('change', val)
    }
  }
}
</script>

<style scoped>
</style>


